import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=0365419b&scoped=true"
import script from "./Contrato.vue?vue&type=script&lang=js"
export * from "./Contrato.vue?vue&type=script&lang=js"
import style0 from "./Contrato.vue?vue&type=style&index=0&id=0365419b&prod&scoped=true&lang=css"
import style1 from "./Contrato.vue?vue&type=style&index=1&id=0365419b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365419b",
  null
  
)

export default component.exports